import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import _ from 'lodash';
import Moment from 'moment';

export default class CitationsChart extends React.Component {
    constructor(props) {
        super(props);

        Highcharts.setOptions({
            lang: {
                thousandsSep: ','
            }
        });
    }

    render() {
        return (
            <div className="CitationsTab-chart">
                <HighchartsReact highcharts={Highcharts} options={this.chartConfig} />
            </div>
        );
    }

    get chartConfig() {
        return {
            credits: false,
            chart: {
                style: {
                    fontFamily: 'roboto-webfont'
                }
            },
            title: { text: 'Citations by year', style: { fontWeight: 'normal' } },
            type: 'line',
            style: {
                fontFamily: 'roboto-webfont, Roboto, sans-serif'
            },
            plotOptions: {
                line: {
                    color: '#1565C0',
                    lineWidth: 6,
                    marker: { radius: 10 }
                }
            },
            xAxis: {
                title: false,
                allowDecimals: false,
                minorTicks: false,
                tickLength: 0,
                lineColor: '#ccd6eb'
            },
            yAxis: {
                title: false,
                labels: { format: '{value:,.0f}' },
                allowDecimals: false
            },
            series: [
                {
                    showInLegend: false,
                    name: 'Citations this year',
                    data: this.data
                }
            ]
        };
    }

    get data() {
        if (!this.props.data.length) return [];

        let dataByYear = _.keyBy(this.props.data, 'id');
        let years = _.range(_.first(this.props.data).id, Moment().year() + 1);

        return _.map(years, function (year) {
            let category = dataByYear[year];

            return category ? { x: year, y: category.count } : { x: year, y: 0 };
        });
    }
}
